export enum RoleFields {
    NAME = 'name',
    DESCRIPTION = 'description',
    CRUD_ACCESS = 'crudAccess',
    GUI_ACCESS = 'guiAccess',
}
